export const formatValue = (value?: number) => {
  if (value === undefined) return;
  if (value > 1) return Math.round(value);
  if (value > 0) return value.toFixed(2);
  return value;
};
